<template>
  <div>
    <md-field :class="{'md-invalid': errors.has(fieldLabel) }" v-for="(field, index) in form[fieldName]" :key="index">
      <label :for=fieldLabel>{{fieldLabel}}</label>
      <md-input :name=fieldLabel :id=fieldId v-model=form[fieldName][index] v-validate="validations" :disabled="sending" />
      <md-button type="button" @click="addField" :disabled="sending">
        <md-icon>add</md-icon>
      </md-button>
      <md-button type="button" v-if="index > 0" @click="removeField(index)" :disabled="sending">
        <md-icon>remove</md-icon>
      </md-button>
      <span class="md-error" v-if="errors.has(fieldLabel)">{{ errors.first(fieldLabel) }}</span>
    </md-field>
  </div>
</template>

<script>
export default {
  name: 'MultipleFields',
  data: () => ({
    form: {}
  }),
  props: ['fieldName', 'fieldLabel', 'fieldId', 'fieldValue', 'sending', 'validations'],
  methods: {
    validateField () {
      return this.$validator.validate().then((result) => {
        this.$emit('setfield', {
          'fieldName': [this.fieldName],
          'fieldValue': this.form[this.fieldName]
        })
        return result
      })
    },
    addField: function () {
      this.form[this.fieldName].push('')
    },
    removeField: function (index) {
      this.form[this.fieldName].splice(index, 1)
    },
    clearField () {
      this.form[this.fieldName] = ['']
    }
  },
  created: function () {
    if (this.fieldValue) {
      this.form[this.fieldName] = this.fieldValue
    } else {
      this.form[this.fieldName] = ['']
    }
  }
}

</script>
